<template>
  <div>JGS Data works!</div>
</template>

<script>
export default {

}
</script>

<style>

</style>
